import { ComponentProps, useCallback } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';

import { openWidget } from 'components/Form';

const StyledButton = styled(Button)`
  margin-left: auto;
  width: fit-content;
`;

const messages = defineMessages({
  submitRequest: {
    id: 'Help.submitRequest',
    defaultMessage: 'Submit a request',
  },
});

type Props = {
  size?: ComponentProps<typeof Button>['size'];
  color?: ComponentProps<typeof Button>['color'];
};

export const SubmitRequest = ({ size, color }: Props) => {
  const requestHelp = useCallback(() => {
    openWidget();
  }, []);

  return (
    <StyledButton
      color={color || 'secondary'}
      size={size || 'medium'}
      onClick={requestHelp}
    >
      <FormattedMessage {...messages.submitRequest} />
    </StyledButton>
  );
};
